import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { publicAssets } from '@utils/url.utils';
import { rem } from 'polished';
import { CantFindYourDreamCarStyled } from '../CantFindYourDreamCarStyled';
export const CantFindYourDreamCarStyledAP = styled(CantFindYourDreamCarStyled)`
    border-radius: unset;

    .img {
        background-image: url('${publicAssets('/images/cantFindYourDreamCarAp_mob.png')}');

        @media (min-width: ${breakpoints.sm}px) {
            background-image: url('${publicAssets('/images/cantFindYourDreamCarAp.png')}');
        }
    }

    .content {
        .txt {
            font-size: ${rem('18px')};
        }
    }
`;
